import script from "./PaymentSectionGooglePay.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentSectionGooglePay.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__